import React from "react"
import "./style.scss"
import MUIDataTable, {MUIDataTableProps} from "mui-datatables";
import IconButton from "@material-ui/core/IconButton";
import {CloudDownload} from "@material-ui/icons";
import {downloadRowsAsCSV, getRowsToBeDownloaded} from "./csvFunctions"

interface props extends MUIDataTableProps {

}

export const SelectedRowsToolbarWithExport = ({selectedRows, data, columns, datatableFileName}) => {
    return (
        <div>
            <IconButton
                onClick={() => downloadRowsAsCSV(getRowsToBeDownloaded(selectedRows, data), columns, datatableFileName)}>
                <CloudDownload/>
            </IconButton>
        </div>
    );
}

const CustomMUIDataTable: React.FC<props> = (props) => {
    // we use this component for further features extensions
    return (<MUIDataTable {...props} />)
}

export default CustomMUIDataTable;